/* eslint-disable @next/next/no-img-element */

import { useState } from 'react';
import Link from 'next/link';

const navItems = [
  { href: '/', label: 'หน้าแรก' },
  { href: '/all-cars', label: 'รถทั้งหมด' },
  { href: '/sell-car', label: 'ขายรถ' },
  { href: '/about', label: 'เกี่ยวกับเรา' },
  { href: '/promotion', label: 'โปรโมชัน' },
  { href: '/contact', label: 'ติดต่อ' },
  { href: '/credit-check', label: 'เช็คเครดิต' },
  { href: '/payment-calculator', label: 'คำนวนค่างวด' },
];

import { useEffect } from 'react';

export default function Navbar({ router }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = href => mounted && router.pathname === href;

  return (
    <nav
      className="bg-white shadow-md md:shadow-lg sticky top-0 z-60 border-b md:border-b-2 border-accent pt-[env(safe-area-inset-top)]"
      aria-label="เมนูหลัก"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 md:h-16">
          {/* LOGO */}
          <Link href="/" prefetch={false} className="flex items-center space-x-2 md:space-x-3">
            <div className="relative w-9 h-9 md:w-12 md:h-12 rounded-full overflow-hidden border md:border-2 border-gold shadow-sm md:shadow-lg">
              <picture>
                <source srcSet="/logo/logo_main_optimized.webp" type="image/webp" />
                <img
                  src="/logo/logo_main.png"
                  alt="ครูหนึ่งรถสวย โลโก้"
                  width="48"
                  height="48"
                  className="w-full h-full object-cover scale-125"
                  loading="eager"
                  fetchpriority="high"
                  decoding="sync"
                />
              </picture>
            </div>
            <div className="text-xl md:text-2xl font-bold text-primary font-prompt">
              ครูหนึ่งรถสวย
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map(item => (
              <Link
                key={item.href}
                href={item.href}
                prefetch={false}
                className={`px-3 py-2 rounded-md text-sm font-medium font-prompt transition-all duration-200 active:scale-[0.95] ${
                  isActive(item.href)
                    ? 'bg-primary text-white'
                    : 'text-primary hover:bg-accent hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden inline-flex items-center justify-center p-1.5 rounded-md text-primary hover:text-white hover:bg-primary focus:outline-none font-prompt font-semibold tracking-wide"
            style={{
              fontSize: '14px',
              fontWeight: '600',
              letterSpacing: '0.025em',
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale',
            }}
            aria-label={mobileOpen ? 'ปิดเมนู' : 'เปิดเมนู'}
            aria-expanded={mobileOpen}
            aria-controls="mobile-nav-menu"
          >
            <span className="flex items-center gap-1">
              {mobileOpen ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileOpen && (
          <div id="mobile-nav-menu" className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white rounded-md mt-2 shadow-lg border border-gray-200">
              {navItems.map(item => (
                <Link
                  key={item.href}
                  href={item.href}
                  prefetch={false}
                  className={`block px-3 py-2 rounded-md font-prompt font-semibold text-base tracking-wide transition-all duration-200 active:scale-[0.95] ${
                    isActive(item.href)
                      ? 'bg-primary text-white'
                      : 'text-primary hover:bg-accent hover:text-white'
                  }`}
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    letterSpacing: '0.025em',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                  }}
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
